import { AddFilled } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import useNavigateTo from "../../../../hooks/useNavigateTo";
import usePermissionCheck from "../../../../hooks/usePermissionCheck";
import { Permissions } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import "./YourDeliveriesHeadline.scss";

interface YourDeliveriesHeadlineProps {
  count: number;
}

const YourDeliveriesHeadline = (props: YourDeliveriesHeadlineProps) => {
  const { t } = useTranslation();
  const { navigateToNewOrder } = useNavigateTo();
  const { hasPermission } = usePermissionCheck();
  const { count } = props;
  const canCreateNewOrder = hasPermission(Permissions.CanCreateInboundDelivery);

  return (
    <div className="your-deliveries">
      <div className="your-deliveries-text">
        {t("yourDeliveries")} {count}
      </div>
      {canCreateNewOrder && (
        <div className="your-deliveries-icon" data-testid="new-order-button">
          <AddFilled size={32} onClick={() => navigateToNewOrder()} />
        </div>
      )}
    </div>
  );
};
export default YourDeliveriesHeadline;
